export const gaPush = (data) => window.dataLayer && window.dataLayer.push(data);
